module.exports = __webpack_public_path__ + "static/408-54fd54a3b90c30be44cfa5e6acdf9434.png";